<template>
  <media-manager 
    v-bind:title="'Manuals'"
    v-bind:containers="[manualsContainer]"
    v-bind:defaultContainer="manualsContainer.name"
    v-bind:disabledContentTypes="['image', 'audio']"
  />
</template>

<script>
import MediaManager from '@/components/MediaManager'
import { Container } from '@/config.js'

export default {
  name: 'GenieManualManager',
  components: {
    MediaManager
  },
  data() {
    return {
      manualsContainer: {
        name: Container.Manuals,
        displayName: 'Manuals'
      }
    }
  }
}
</script>
